import { footerSections } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:gap-12">
          <div>
            <p className="font-heading text-2xl text-background-50">蝌蚪黑料</p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              把事件的源头、节点与走向排成一条线，让只刷到一半的人也能从头看懂。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-200">
                <i className="ri-timeline-view text-base" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-200">
                <i className="ri-discuss-line text-base" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-200">
                <i className="ri-bookmark-3-line text-base" />
              </span>
            </div>
          </div>

          {footerSections.map((section) => (
            <nav key={section.title}>
              <h4 className="font-heading text-base text-background-50">
                <a href="#top" className="cursor-pointer">
                  {section.title}
                </a>
              </h4>
              <ul className="mt-5 space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/15 pt-7 md:flex-row md:items-center md:justify-between">
          <p className="max-w-2xl text-xs leading-relaxed text-background-400">
            本站为演示站点，页面内容均为虚构占位示例，不指向任何真实个人、机构或事件。
          </p>
          <p className="font-label text-xs text-background-400">
            © 2026 蝌蚪黑料 · 时间线梳理站
          </p>
        </div>
      </div>
    </footer>
  );
}